var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconScreenshare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8.5,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44298 9C5.67792 9 5.86393 8.89278 6.09887 8.69295L9.76016 5.25688C9.93147 5.0863 10 4.90596 10 4.75C10 4.58916 9.93637 4.4137 9.76016 4.23825L6.09887 0.836296C5.83456 0.612099 5.68771 0.5 5.45277 0.5C5.11503 0.5 4.87518 0.768062 4.87518 1.08974V2.80046H4.74792C1.46353 2.80046 0 4.89622 0 8.28354C0 8.74169 0.234949 8.99513 0.509055 8.99513C0.71953 8.99513 0.939794 8.93664 1.10622 8.62959C1.88938 7.17231 2.98581 6.70441 4.74792 6.70441H4.87518V8.43463C4.87518 8.75631 5.11503 9 5.44298 9Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconScreenshare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-screenshare.3830dc68d575f1b71b06eeb82769913c.svg";